import React from 'react';

import HomeVisits from './services/HomeVisits';
import VideoConsultations from './services/VideoConsultations';
import FamilyPhysicians from './services/FamilyPhysicians';
import LabTests from './services/LabTests';
import SeniorCitizens from './services/SeniorCitizens';
import Vaccinations from './services/Vaccinations';
import InnerHeroBanner from './InnerHeroBanner';

export default function OurServices() {
  return (
    <>
      <InnerHeroBanner />
      <div className='our-services'>
       
        <HomeVisits />
        <VideoConsultations />
        <FamilyPhysicians />
        <LabTests />
        <SeniorCitizens />
        <Vaccinations />
      </div>
    </>
  );
}
